
import Vue, { PropType } from 'vue';

// Types
import { CandidateJobBuilder, JobWorkExperience } from '~/utils/candidate';
import { jobWorkExperienceValidator } from '~/utils/validators';

// Components
import Input from '~/components/builders/Base/Input.vue';
import YearMonthPicker from '~/components/builders/YearMonthPicker.vue';
import Checkbox from '~/components/builders/Base/Checkbox.vue';
import RichTextEditor from '~/components/builders/RichTextEditor.vue';

export default Vue.extend({
    name: 'WorkExperienceListItemForm',
    components: { Input, Checkbox, YearMonthPicker, RichTextEditor },
    props: {
        value: {
            type: Object as PropType<JobWorkExperience>,
            required: true,
        },
    },
    data() {
        return {
            workExperience: { ...this.value } as JobWorkExperience,
        };
    },
    computed: {
        isValid(): boolean {
            return jobWorkExperienceValidator(this.workExperience);
        },
        isTempItem(): boolean {
            return CandidateJobBuilder.isTempItem(this.workExperience);
        },
    },
    methods: {
        updateIsCurrentJob(isCurrentJob: boolean) {
            this.workExperience.isCurrentJob = isCurrentJob;
            if (isCurrentJob) {
                this.workExperience.end = null;
            }
        },
    },
});
